import { Application } from '@hotwired/stimulus'
import { reportErrorToSentry } from 'utils/sentry'

const application = Application.start()

// Configure Stimulus development experience
if (process.env.RAILS_ENV === 'development') {
  application.debug = true
  window.Stimulus = application
}

application.handleError = (error, message, detail) => {
  reportErrorToSentry(error, { message, detail })
}

export { application }
